import React from 'react';
import { cn, STATUS_CONFIG } from '@/lib/utils';
import {
  Search, Loader, Mail, CheckCircle, XCircle, Ban, Circle, Pause
} from 'lucide-react';

const iconMap = {
  Search, Loader, Mail, CheckCircle, XCircle, Ban, Circle, Pause
};

export function StatusBadge({ status, size = 'sm', pulse = false }) {
  const config = STATUS_CONFIG[status] || { label: status, color: 'text-gray-400', bg: 'bg-gray-400/10' };
  const IconComp = iconMap[config.icon] || Circle;
  const isActive = ['researching', 'in_progress', 'waiting_email'].includes(status);

  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 font-medium',
        size === 'sm' ? 'text-xs' : 'text-sm',
        config.color,
        `status-bg-${status}`
      )}
    >
      <IconComp
        className={cn(
          'w-3 h-3',
          isActive && pulse && 'pulse-dot',
          status === 'in_progress' && 'animate-spin'
        )}
      />
      {config.label}
    </span>
  );
}
